// extracted by mini-css-extract-plugin
module.exports = {"base":"organism1-m__base__3jt-M"};